module.exports = __webpack_public_path__ + "media/brewling.5c5cbde1.webm";